<ng-container *ngIf="moduleManager.settingsView === 'cxOneModal'">
    <div cvModuleCxoneCustomSettingSection after="rec" [moduleManager]="moduleManager">
        <!-- Additional Filters -->
        <div class="form-group">
            <!-- uncomment when attribute selector is removed -->
            <p class="cxone-section-header" style="font-family: openSans-semiBold" cvLocalizedText langSection="CXOne_Modal" langKey="Additional_Filters">Additional Filters</p>
            <cv-metric-dynamic-filters [selectedMetrics]="selectedMetrics" [moduleManager]="moduleManager"></cv-metric-dynamic-filters>
        </div>
    </div>
</ng-container>